import once from 'lodash/once';
import context from './context';
import { frontEndPerformanceMonitoringEnabled } from '../selectors/feature';

const warnOncePerformanceMark = once(console.warn);
const warnOncePerformanceMeasure = once(console.warn);
const warnOncePerformanceClearMarks = once(console.warn);
const warnOncePerformanceClearMeasures = once(console.warn);

export const canUsePerformanceMark = () =>
  typeof context.performance !== 'undefined' &&
  typeof context.performance.mark === 'function' &&
  typeof context.performance.clearMarks === 'function';

export const canUsePerformanceMeasure = () =>
  typeof context.performance !== 'undefined' &&
  typeof context.performance.measure === 'function' &&
  typeof context.performance.clearMeasures === 'function';

export const canUsePerformanceObserver = () =>
  typeof context.PerformanceObserver !== 'undefined';

export const isMonitoringEnabled = store =>
  canUsePerformanceObserver() &&
  frontEndPerformanceMonitoringEnabled(store.getState());

export const performanceMark = name => {
  if (canUsePerformanceMark()) {
    try {
      context.performance.mark(name);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceMark(
      'Unable to monitor performance: The performance.mark method from the User Timing API is not available in this context.'
    );
  }
};

export const performanceMeasure = (name, startMarkName, endMarkName) => {
  if (canUsePerformanceMeasure()) {
    try {
      context.performance.measure(name, startMarkName, endMarkName);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceMeasure(
      'Unable to monitor performance: The performance.measure method from the User Timing API is not available in this context.'
    );
  }
};

export const performanceClearMarks = name => {
  if (canUsePerformanceMark()) {
    try {
      context.performance.clearMarks(name);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceClearMarks(
      'Unable to monitor performance: The performance.clearMarks method from the User Timing API is not available in this context.'
    );
  }
};

export const performanceClearMeasures = name => {
  if (canUsePerformanceMeasure()) {
    try {
      context.performance.clearMeasures(name);
    } catch (error) {
      console.error(error);
    }
  } else {
    warnOncePerformanceClearMeasures(
      'Unable to monitor performance: The performance.clearMeasures method from the User Timing API is not available in this context.'
    );
  }
};



// WEBPACK FOOTER //
// ./js/util/performance.js